<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.gradingScale')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="text-right mb-3">
                    <b-button variant="primary" :title="$t('button.save')" @click="submit()"
                        v-if="permissions.editSettingsGradingscale">
                        <i class="far fa-save"></i></b-button>

                    <b-button variant="info" @click="newGradingScale()" :title="$t('button.new')">
                        <i class="fas fa-plus-circle"></i></b-button>
                </div>

                <div role="tablist">
                    <b-card no-body class="mb-1" v-for="(tab, tabIndex) in tabs" :key="tabIndex">
                        <b-card-header header-bg-variant="light" header-tag="header" role="tab">
                            <template v-if="editing === tabIndex">
                                <b-form inline class="d-inline" @submit.prevent="updateTitle(tabIndex)">
                                    <b-input v-model.trim="tab.Title" class="mr-2"></b-input>
                                    <b-button @click="updateTitle(tabIndex)" :title="$t('button.save')">
                                        <i class="far fa-save"></i>
                                    </b-button>
                                </b-form>
                            </template>

                            <template v-else>
                                <b-button variant="link" @click.prevent="toggleGradingScale(tabIndex)">{{tab.Title}}
                                </b-button>
                            </template>

                            <div class="float-right d-inline">
                                <b-button variant="info" @click="editing = tabIndex" :title="$t('button.edit')">
                                    <i class="fas fa-pencil-alt"></i></b-button>
                                <b-button variant="warning" @click="cloneGradingScale(tabIndex)"
                                    :title="$t('button.clone')">
                                    <i class="fas fa-clone"></i></b-button>
                                <b-button variant="danger" @click="removeGradingScale(tabIndex)"
                                    :title="$t('button.delete')">
                                    <i class="fa fa-trash"></i></b-button>
                            </div>
                        </b-card-header>

                        <b-collapse :id="`accordion-${tabIndex}}`" :visible="toggle === tabIndex"
                            :accordion="`my-accordion-${tabIndex}`" role="tabpanel">

                            <b-card-body>
                                <div class="form-group">
                                    <label>{{$t('form.setting.programCode')}}</label>
                                    <v-select v-model="tab.ProgramCode" :options="programCodes" multiple></v-select>
                                </div>

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>{{$t('form.setting.descGrade')}}</th>
                                            <th>{{$t('form.setting.ectsGrade')}}</th>
                                            <th>{{$t('form.setting.grade')}}</th>
                                            <th>{{$t('form.setting.maxPercentage')}}</th>
                                            <th>{{$t('form.setting.minPercentage')}}</th>
                                            <th class="text-right">
                                                <b-button @click="addGradingScaleCondition(tabIndex)"
                                                    :title="$t('button.new')">
                                                    <i class="fas fa-plus-circle"></i>
                                                </b-button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in tab.GradingScale" :key="index">
                                            <td>
                                                <b-form-select v-model="item.descGrade" :options="descGrades">
                                                </b-form-select>
                                            </td>
                                            <td>
                                                <b-form-select v-model="item.ectsGrade" :options="ectsGrades">
                                                </b-form-select>
                                            </td>
                                            <td>
                                                <b-form-input v-model="item.grade"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input v-model="item.maxPercentage"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input v-model="item.minPercentage"></b-form-input>
                                            </td>
                                            <td class="text-right">
                                                <b-button variant="danger"
                                                    @click="removeGradingScaleCondition(tabIndex, index)"
                                                    :title="$t('button.remove')">
                                                    <i class="fas fa-minus-circle"></i>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["permissions"],

        data() {
            return {
                alert: false,
                alertClass: null,
                alertMessage: null,

                isLoading: false,
                fullPage: true,
                toggle: 0,
                editing: false,

                tabs: [{
                    Title: 'Grading Scale 1',
                    ProgramCode: [],
                    GradingScale: []
                }],
                programCodes: [],
                descGrades: [],
                ectsGrades: [],
            };
        },

        mounted() {
            if (!this.permissions.viewSettingsGradingscale) {
                return this.$router.push('/');
            }

            this.getInitialData();
            this.getSettings();
        },

        methods: {

            /**
             * Fetch initial data for grading scale
             */
            getInitialData() {
                axios
                    .get('/api/settings/initial-data')
                    .then(response => {
                        this.descGrades = response.data.descGrades;
                        this.ectsGrades = response.data.ectsGrades;
                        this.programCodes = response.data.programCodes;
                    });
            },

            /**
             * Toggle Grading Scale
             * 
             * @param int index of active list
             */
            toggleGradingScale(index) {
                if (this.toggle === index) {
                    this.toggle = false;
                    return;
                }

                this.toggle = index;
            },

            /**
             * Add new grading scale formula
             */
            newGradingScale() {
                this.tabs.push({
                    Title: 'Grading Scale ' + (this.tabs.length + 1),
                    ProgramCode: [],
                    GradingScale: []
                });

                this.toggle = this.tabs.length - 1;
            },

            /**
             * Clone active grading scale formula
             */
            cloneGradingScale(index) {
                this.tabs.push({
                    ...this.tabs[index]
                });

                this.toggle = this.tabs.length - 1;
            },

            /**
             * Remove grading scale formula
             * 
             * @param int index of active list
             */
            removeGradingScale(index) {
                if (this.tabs[index].ProgramCode.length > 0) {
                    alert(this.$t('form.setting.programAssigned'));
                    return;
                }

                if (this.tabs.length === 1) {
                    alert(this.$t('form.setting.minGradingScale'));
                    return;
                }

                if (confirm(this.$t('form.validation.delete'))) {
                    this.tabs.splice(index, 1);
                }
            },

            /**
             * Validate and save current grading scale title
             */
            updateTitle(index) {
                if (this.tabs[index].Title.length < 1) {
                    alert(this.$t('form.setting.emptyTitle'));
                    return;
                }

                this.editing = false;
            },

            /**
             * Add condition in grading scale
             * 
             * @param int index of questioning grading scale list
             */
            addGradingScaleCondition(index) {
                this.tabs[index].GradingScale.push({
                    descGrade: null,
                    ectsGrade: null,
                    grade: null,
                    maxPercentage: null,
                    minPercentage: null
                });
            },

            /**
             * Remove condition from grading scale
             * 
             * @param int index of questioning grading scale
             * @param int index of questioning condition under grading scale
             */
            removeGradingScaleCondition(tabIndex, index) {
                if (confirm(this.$t('form.validation.delete')) !== false) {
                    this.tabs[tabIndex].GradingScale.splice(index, 1);
                }
            },

            /**
             * Save grading scale
             */
            submit() {

                if (this.tabs.length === 0) {
                    alert(this.$t('form.setting.noGradingScale'));
                    return;
                }

                this.isLoading = true;

                axios
                    .post("/api/settings?name=grading-scale", {
                        value: this.tabs
                    })
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);

                            this.toggle = 0;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error saving grading scale.');
                    });
            },

            /**
             * Fetch grading scale
             */
            getSettings() {
                this.isLoading = true;

                axios
                    .get("/api/settings?name=grading-scale")
                    .then(response => {

                        if (response.data.length > 0) this.tabs = response.data;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error fetching grading scales.');

                        this.isLoading = false;
                    });
            },

            /**
             * Display alert or notification
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>
